export const MATCHUP_FETCH_DATA_REQUEST = 'MATCHUP/FETCH_DATA_REQUEST';
export const MATCHUP_FETCH_DATA_ERROR = 'MATCHUP/FETCH_DATA_ERROR';
export const MATCHUP_FETCH_DATA_SUCCESS = 'MATCHUP/FETCH_DATA_SUCCESS';
export const MATCHUP_REFETCH_DATA = 'MATCHUP/REFETCH_DATA';

export const MATCHUP_UPDATE_REQUEST = 'MATCHUP/UPDATE_REQUEST';
export const MATCHUP_UPDATE_ERROR = 'MATCHUP/UPDATE_ERROR';
export const MATCHUP_UPDATE_SUCCESS = 'MATCHUP/UPDATE_SUCCESS';
